import { render } from "./TeamListCard.vue?vue&type=template&id=1ec02339"
import script from "./TeamListCard.vue?vue&type=script&lang=js"
export * from "./TeamListCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__